import { defineRecipe } from '@chakra-ui/react';

export const iconRecipe = defineRecipe({
  defaultVariants: {
    size: 'md',
  } as Record<string, string>,
});
